import { mapActions, mapGetters } from 'vuex'
import { format, parseDateString } from '@/plugins/moment'
import Configuration from '@/agilis/util/Configuration'

export default {
  name: 'TrackerHistory',

  data () {
    return {
      historyArray: null,
      defaultHistoryTabs: [
        { id: 'businessData', label: 'label.businessData', types: ['SYSTEM_UPDATE', 'STATE_CHANGE'] }
      ]
    }
  },

  computed: {
    ...mapGetters({
      selectedContext: 'contextStore/selectedContext',
      applicationId: 'contextStore/applicationId',
      trackerTypeId: 'contextStore/trackerTypeId',
      trackerType: 'contextStore/trackerType',
      trackerId: 'contextStore/trackerId',
      loading: 'loaderStore/loading',
      historyTabs: 'configurationStore/historyTabs'
    }),

    historyTabsConfiguration () {
      return this.trackerType.historyTabs || this.historyTabs || this.defaultHistoryTabs
    },

    userHistoryTabs () {
      return this.historyTabsConfiguration.filter(historyTab => {
        const featureId = `history?tab=${historyTab.id}`
        if (Configuration.auth.userCanAccessFeature(this.selectedContext, featureId)) {
          return historyTab
        }
      })
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError',
      'startLoader': 'loaderStore/startLoader',
      'stopLoader': 'loaderStore/stopLoader'
    }),

    async fetchHistory () {
      const url = this.$axios.agilisUrlTrackerHistory(
        this.applicationId,
        this.trackerTypeId,
        this.trackerId)

      try {
        this.startLoader({ id: 'tracker-history' })
        const response = await this.$axios
          .get(url, this.$axios.agilisRequestConfig(url))

        this.historyArray = response.data.filter(h => h.historyType !== 'USER_NOTE')
      } catch (error) {
        this.notifyError(error)
      } finally {
        this.stopLoader({ id: 'tracker-history' })
      }
    },

    formatDateTime (dateTime, forceAsString = false) {
      if (dateTime) {
        const mDateTime = parseDateString(dateTime)
        const now = parseDateString('now')
        const diffInSec = Math.abs(mDateTime.diff(now, 'seconds', true))
        const diffInMin = Math.abs(mDateTime.diff(now, 'minutes', true))
        const diffInHours = Math.abs(mDateTime.diff(now, 'hours', true))

        const dateAsString = format(dateTime, this.$t('format.dateTime'))

        if (forceAsString) {
          return dateAsString
        } else if (diffInSec < 30) { // <30sec
          return this.$t('label.timeNow')
        } else if (diffInMin < 1) { // <1min
          return this.$t('label.time1MinAgo')
        } else if (diffInMin < 60) { // <60min
          const n = Math.floor(diffInMin)
          return this.$t('label.timeNMinAgo', { n })
        } else if (diffInHours < 2) { // <2h
          return this.$t('label.time1HourAgo')
        } else if (diffInHours < 24) { // <24h
          const n = Math.floor(diffInHours)
          return this.$t('label.timeNHourAgo', { n })
        }

        return dateAsString
      }
    },

    showTimeIcon (dateTime) {
      if (dateTime) {
        const mDateTime = parseDateString(dateTime)
        const diff = Math.abs(mDateTime.diff(parseDateString('now')))

        if (diff < 86400000) { // <24h
          return true
        }

        return false
      }
    },

    onPanelClick (...args) {
      if (this.historyArray === null) {
        this.fetchHistory()
      }
    },

    forceReload () {
      if (this.historyArray !== null) {
        this.fetchHistory()
      }
    },

    makeHeaders (note) {
      const header = this.$t('label.historyTimestamp', { author: note.updatedBy, updated: this.formatDateTime(note.updatedTime, true) })
      return [{
        text: header,
        value: 'history'
      }]
    },

    makeItems (note) {
      const lines = note.text.split('\n').filter(line => {
        return line.startsWith('NEW') || line.startsWith('OLD') || (!line.endsWith(' = ') && !line.endsWith(' = null'))
      })
      return [{
        history: lines.join('\n')
      }]
    },

    showHistoryTabItem (tabTypes) {
      return this.historyArray.filter(note => tabTypes.includes(note.historyType)).length > 0
    },

    historyArrayFilterByType (tabTypes) {
      return this.historyArray.filter(note => tabTypes.includes(note.historyType))
    }
  }
}
